import { apiCall } from './generated/gqlClient';

export const getProviderAnalyticsApiRequest = async () => {
  const query = `
    query getProviderAnalytics {
      getProviderAnalytics {
        users {
          id
          created
        }
        orders {
          id
          productId
          reservationId
          subscriptionId
          userMembershipId
          userPlanId
          date
          price
          paid
          paidWithUserMembershipId
        }
        reservations {
          id
          created
          userId
          customerId
          serviceId
          startTime
          status
          resourceIds
        }
        subscriptions {
          id
          created
          userId
          customerId
          serviceId
          startTime
          status
        }
        sessionBookings {
          id
          created
          userId
          customerId
          serviceId
          startTime
          status
          resourceIds
        }
      }
    }
  `;

  const response = await apiCall({ query });
  if (response.success) return { ...response, data: { ...response.data, analyticsVersion: 'full' } };

  // A locally running proxy can still have the previous generated GraphQL schema.
  // Recover the KPIs supported by that schema, but mark richer booking facts as
  // unavailable so the dashboard never presents invented zeroes for them.
  const unsupportedField = response.errors?.some(error =>
    /Cannot query field ("paid"|"userId"|"customerId"|"serviceId"|"startTime"|"status"|"resourceIds"|"sessionBookings")/.test(error.message)
  );
  if (!unsupportedField) return response;

  const legacyQuery = `
    query getProviderAnalytics {
      getProviderAnalytics {
        users { id created }
        orders { id productId reservationId subscriptionId userMembershipId userPlanId date price paidWithUserMembershipId }
        reservations { id created }
        subscriptions { id created }
      }
    }
  `;
  const legacy = await apiCall({ query: legacyQuery });
  if (!legacy.success) return legacy;

  return {
    ...legacy,
    data: {
      ...legacy.data,
      analyticsVersion: 'legacy',
      // The legacy endpoint already limits orders to paid OR membership-paid.
      orders: (legacy.data.orders || []).map(order => ({ ...order, paid: !order.paidWithUserMembershipId })),
    },
  };
};
